/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/css/index.css"
import "gatsby-plugin-breadcrumb/gatsby-plugin-breadcrumb.css"